// The typed edge (ADR-001 §4.2): hc<AppType> over the gateway's exported route
// types, with portal defaults (credentials: 'include' — the opaque session
// cookie is the only credential). Same seam as the admin/staff portals; the
// student portal is PUBLIC-AWARE at the ROUTING layer (anonymous reaches the
// catalogue), but the client itself is identical — the /opac reads decide
// anonymous-vs-gated server-side, and the /me surface rides the same cookie.
//
// `import type` is load-bearing: a VALUE import of '@erp/gateway' would drag Hono
// routing, Zod schemas and every handler into the browser bundle. This type-only
// import IS the M1 exit-criterion seam — if the gateway's AppType drifts (route
// removed, shape changed), the portal fails TYPECHECK here.
import type { AppType } from "@erp/gateway";
import { createApiClient } from "@erp/api-client";

export const client = createApiClient<AppType>("/");
export type ApiClient = typeof client;
